import {MainAppBar} from "~/ui/AppBar/MainAppBar";

import React from "react";
import {NotFound} from "~/components/ErrorBlocks/NotFound";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";


const NotFoundPage = () => {
    return (
        <>
            <MainAppBar disableActions={true}/>
            <AbsoluteContainer>
                <NotFound/>
            </AbsoluteContainer>
        </>
    )
}


export default NotFoundPage;